module.exports = __webpack_public_path__ + "img/index-carousel-1.a64fe61d.jpg";